import { render, staticRenderFns } from "./addroles.vue?vue&type=template&id=cf8998c0&scoped=true&"
import script from "./addroles.vue?vue&type=script&lang=js&"
export * from "./addroles.vue?vue&type=script&lang=js&"
import style0 from "./addroles.vue?vue&type=style&index=0&id=cf8998c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8998c0",
  null
  
)

export default component.exports